export default __webpack_public_path__ + "static/QConSF_2025_PC-caccbfbcc4984da436a4e80c33fa47c3.png";